<template>
  <div class="struct_dev">
    <div class="top">
      <div class="top__img">
        <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/dev_icon.png" width="100%"/>
      </div>
      <div class="top__large">工程科技研发</div>
      <div class="top__small" style="margin-top:20px;"> 基于华南理工大学科研团队的技术支撑，公司在工程设计、施工和运营阶段均有丰厚的新技术沉淀，创新转化能力强大。</div>
    </div>
    <div class="content">
      <div v-for="item in structList" :key="item.id" class="contentBox">
        <div class="title">{{item.title}}</div>
        <img :src="item.image" alt="" width="100%">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'struct_dev',
  data() {
    return {
      projectList: [
        '面向区域级结构健康监测与安全评估的CLOUD-BIM决策支持平台关键技术研究',
        '融合Cloud-BIM信息技术的新光大桥健康监测系统升级关键技术研究',
        '装配式建筑项目管理及应用技术指南专项研究服务',
        '广州市建筑业转型升级前期战略研究',
        '广州市智慧城地下综合管廊关键技术与安全运营模式研究',
        ''
      ],
      structList: [
        {
          id: 'struct1',
          title: '随机振动领域ETDM应用',
          image: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_dev1.png'
        },
        {
          id: 'struct2',
          title: '健康监测大数据人工智能应用',
          image: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_dev2.png'
        },
        {
          id: 'struct3',
          title: '面向工程计算机视觉技术应用',
          image: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_dev3.png'
        },
      ]
    }
  },
  mounted () {
    document.body.scrollIntoView()
  }
}
</script>
<style lang="less" scoped>
.struct_dev {
  .top {
    width: 100%;
    height: 280px;
    background: url('https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_dev_banner.png') center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: #fff;
    &__img {
      width: 71px;
      height: 66px;
    }
    &__large {
      margin-top: 16px;
      font-size: 24px;
      line-height: 1.5em;
    }
    &__small {
      font-size: 14px;
      line-height: 1.5em;
    }
  }
  .content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 64px;
    .contentBox{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 20px 0;
      .title {
        margin: 48px 0 50px;
        position: relative;
        font-size: 30px;
        line-height: 1.5em;
        font-weight: bold;
        color: #000;
      }
      .title::after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 50px;
        height: 8px;
        background-color: #FAAD14;
      }

    }
  }
}
</style>
